import styled from 'styled-components';
import { breakpoints } from '@soluto-private/mx-asurion-ui-react';

export const InputContainer = styled.div`
	${breakpoints.xxl} {
		max-width: 41.5rem;
	}
`;
